module.exports = __webpack_public_path__ + "40c32b0f659ae71cb37f659c59b6c160.png";